var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"showLogsModal",attrs:{"sticky-header":"","hide-footer":"","centered":"","title":"User Data Change Logs","size":"xl"}},[_c('div',[_c('b-table',{attrs:{"striped":"","hover":"","fields":[
        { key: 'date', sortable: true },
        { key: 'userEmail', sortable: true },
        { key: 'grid', sortable: true }
        ,
        { key: 'oldValue' }
        ,
        { key: 'newValue' }
      ],"items":_vm.logs}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }